import { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";

//Helper functions
import { getSettings } from '../../../settings/Helpers';

//3rd party
import toast, { Toaster } from 'react-hot-toast';
import * as Icon from 'react-bootstrap-icons';

//Components
import BottomNav from '../../../components/bottomnav/bottomnav';
import DashboardHeader from '../../../components/dashboard/header';

//styles
import './menu.css';

const Menu = (props) => {

    //Get props
    const page = props.page;

    //Set variables
    const navigate = useNavigate();
    const medewerker = JSON.parse(localStorage.getItem('medewerker'));
    const loggedIn = localStorage.getItem('ingelogd');

    //Set navitems and for which user role
    const navitems = [
        {
            name: 'Dashboard',
            link: '/',
            icon: <Icon.House />,
            roles: ['authenticated', 'gebruiker_en_schade_melden', 'controleur', 'super_admin']
        },
        {
            name: 'Uren registreren',
            link: '/registreren',
            icon: <Icon.ClockHistory />,
            roles: ['authenticated', 'gebruiker_en_schade_melden', 'controleur', 'wagenpark', 'wagenpark_en_controleur', 'schadebeheer', 'loonadministratie', 'super_admin']
        },
        {
            name: 'Uren controleren',
            link: '/uren-controleren',
            icon: <Icon.ClockFill />,
            roles: ['controleur', 'wagenpark_en_controleur', 'schadebeheer', 'super_admin'],
            is_vervanger: true
        },
        // {
        //     name: 'Declareren',
        //     link: '/declareren',
        //     icon: <Icon.Receipt />,
        //     roles: ['authenticated', 'controleur', 'wagenpark', 'wagenpark_en_controleur', 'schadebeheer', 'loonadministratie', 'super_admin']
        // },
        // {
        //     name: 'Declaraties controleren',
        //     link: '/declaraties-controleren',
        //     icon: <Icon.ReceiptCutoff />,
        //     roles: ['controleur', 'wagenpark_en_controleur', 'super_admin'],
        //     is_vervanger: true
        // },
        {
            name: 'Wiki',
            link: '/wiki',
            icon: <Icon.InfoCircle />,
            roles: ['authenticated', 'gebruiker_en_schade_melden', 'controleur', 'wagenpark', 'wagenpark_en_controleur', 'schadebeheer', 'loonadministratie', 'super_admin']
        }
    ];

    //Logout function
    const logout = () => {
        localStorage.removeItem('bearerToken');
        localStorage.removeItem('ingelogd');
        localStorage.removeItem('medewerker');
        localStorage.removeItem('videotutorials');
        navigate('/login');
    }

    //Check if user is authenticated, else redirect to login
    useEffect(() => {
        //Get settings and check for maintenance
        const settings = getSettings();
        settings.then((result) => {
            if (result.onderhoudsmodus) {
                navigate('/onderhoud');
            }
        });
        if (loggedIn !== 'true') {
            navigate('/login');
        }
    }, []);
    
    return (
    <div id="main" className="dashboard">
        <div className="dashboard-content">
            <DashboardHeader title="Menu" />
            <div className="list-menu-items">
                    {
                        navitems.map((item, index) =>  {
                            if (item.roles.includes(medewerker.gebruiker.role.type) || item.is_vervanger === medewerker.is_vervanger) {
                                return (
                                    <Link key={index} to={item.link} className={page === item.link ? 'item current' : 'item'}>{item.icon}<span>{item.name}</span></Link>
                                )
                            }
                        })
                    }
                    <div className="logout-section">
                        <p className="logout-menu" onClick={logout}><Icon.BoxArrowLeft /> Uitloggen</p>
                    </div>
                </div>
            <Toaster />
        </div>
        <BottomNav page="/menu" />
    </div>
    );
};
export default Menu;